import { useEffect } from "react";
import { useAxios } from "../../utils/useAxios";
import { useCountData } from "../../context/CountDataContext";

const __class = "text-sm p-1 px-3 rounded";
const LoadStatusFilter = () => {
  // const { mutate, isPending, res } = useAxios({
  //   url: "/api/auth/statusfilter",
  // });
  const { mutate, isPending, res } = useAxios({
    url: "/api/auth/statuscount",
  });
  useEffect(() => {
    mutate({
      formId: "load",
    });
  }, []);

  const { setCountData } = useCountData();

  const handleChange = (e: any) => {
    setCountData(e);
  };

  return (
    <>
      <div className="py-1 border-b mb-2 font-medium">Load Status</div>
      <div className="flex flex-wrap gap-1 mb-2">
        <button
          className={`bg-green-600 text-white ${__class}`}
          onClick={() => !isPending && handleChange(res?.data?.data?.all)}
        >
          All ({isPending ? 0 : res?.data?.count?.all})
        </button>
        <button
          className={`bg-gray-400 text-white ${__class}`}
          onClick={() =>
            !isPending && handleChange(res?.data?.data?.today_pickup)
          }
        >
          Today Pickups ({isPending ? 0 : res?.data?.count?.today_pickup})
        </button>
        <button className={`bg-sky-400 text-white ${__class}`}>
          Tendered (0)
        </button>
        <button
          className={`bg-blue-800 text-white ${__class}`}
          onClick={() =>
            !isPending && handleChange(res?.data?.data?.need_driver)
          }
        >
          Need Driver ({isPending ? 0 : res?.data?.count?.need_driver})
        </button>
        <button className={`bg-pink-700 text-white ${__class}`}>
          Ready For Dispatch (0)
        </button>
        <button className={`bg-red-700 text-white ${__class}`}>
          App Risks (0)
        </button>
        <button className={`bg-yellow-700 text-white ${__class}`}>
          At Yard (0)
        </button>
        <button
          className={`bg-green-900 text-white ${__class}`}
          onClick={() => !isPending && handleChange(res?.data?.data?.active)}
        >
          Active ({isPending ? 0 : res?.data?.count?.active})
        </button>
        <button className={`bg-indigo-600 text-white ${__class}`}>
          Tracking Completed (0)
        </button>
        <button
          className={`bg-green-600 text-white ${__class}`}
          onClick={() => !isPending && handleChange(res?.data?.data?.deliverd)}
        >
          Completed ({isPending ? 0 : res?.data?.count?.deliverd})
        </button>
        <button className={`bg-slate-900 text-white ${__class}`}>
          Missing BOL (0)
        </button>
        <button className={`bg-cyan-600 text-white ${__class}`}>
          Missing POD (0)
        </button>
        <button className={`bg-amber-600 text-white ${__class}`}>
          On Hold (0)
        </button>
        <button
          className={`bg-red-600 text-white ${__class}`}
          onClick={() => !isPending && handleChange(res?.data?.data?.lateload)}
        >
          Late Load ({isPending ? 0 : res?.data?.count?.lateload})
        </button>
        <button
          className={`bg-blue-700 text-white ${__class}`}
          onClick={() => !isPending && handleChange(res?.data?.data?.deliverd)}
        >
          Ready For Accounting ({isPending ? 0 : res?.data?.count?.deliverd})
        </button>
        <button
          className={`bg-slate-400 text-white ${__class}`}
          onClick={() => !isPending && handleChange(res?.data?.data?.cencelled)}
        >
          Cancelled/TONU ({isPending ? 0 : res?.data?.count?.cencelled})
        </button>
      </div>
    </>
  );
};

export default LoadStatusFilter;
